import React, { Component } from "react";
import moment from 'moment';
import ImagemFukyo from "../Imagem-Fukyo/Imagem-Fukyo";
import './Content-List.scss';
import Geral from '../../Utils/Geral';
import { Configurations } from '../../Utils/Configurations';



class ContentList extends Component {

    constructor(props) {
        super(props);

        this.renderizaCardsContent = this.renderizaCardsContent.bind(this);
        this.defineRota = this.defineRota.bind(this);


        this.Configurations = new Configurations();

        this.state = {
           
        }
    }

    renderizaCardsContent(item) {
        let _layout;

        switch (item.tipo) {
            case 1:
                _layout =
                    <div className="card-body pt-3">
                        <div className="row no-gutters">
                            <div className="col-3 d-lg-block d-none cursor-pointer" onClick={() => {
                                this.props.history.push(this.defineRota(item))
                            }}>
                                <ImagemFukyo
                                    className={`img img-fluid`}
                                    src={item.imagem}
                                    alt={`imagem-destaque`}
                                />
                            </div>
                            <div className="col-lg-9 col-12  px-lg-4 px-0 cursor-pointer" onClick={() => {
                                this.props.history.push(this.defineRota(item))

                            }}>
                                <div className="row">
                                    <div className="col-12">
                                        <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                                        <p className="infos-ativos"><strong>Seção:</strong> {item.secao}</p>
                                        <p className="infos-ativos"><strong>Data de publicação:</strong> {moment(item.dtPublicacao).format("DD/MM/YYYY")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                break;
            case 2:
                _layout = <div className="card-body pt-3">
                    <div className="row no-gutters">
                        <div className="col-3 d-lg-block d-none cursor-pointer" onClick={() => {
                            this.props.history.push(this.defineRota(item))

                        }}>
                            <ImagemFukyo
                                className={`img img-fluid`}
                                src={item.imagem}
                                alt={`imagem-destaque`}
                            />
                        </div>
                        <div className="col-lg-9 col-12  px-lg-4 px-0 cursor-pointer" onClick={() => this.props.history.push(this.defineRota(item))
                        }>
                            <div className="row">
                                <div className="col-12">
                                    <p className="infos-ativos"><strong>Programa:</strong> {item.nomePrograma}</p>
                                    <p className="infos-ativos"><strong>Episódio:</strong> {item.nomeEpisodio}</p>
                                    <p className="infos-ativos"><strong>Data de publicação:</strong> {moment(item.dtPublicacao).format("DD/MM/YYYY")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                break;
            case 3:
                _layout = <div className="card-body pt-3">
                    <div className="row no-gutters">
                        <div className="col-3 d-lg-block d-none cursor-pointer" onClick={() => {
                            this.props.history.push(this.defineRota(item))

                        }}>
                            <ImagemFukyo
                                className={`img img-fluid`}
                                src={item.imagem}
                                alt={`imagem-destaque`}
                            />
                        </div>
                        <div className="col-lg-9 col-12  px-lg-4 px-0 cursor-pointer" onClick={() => this.props.history.push(this.defineRota(item))
                        }>
                            <div className="row">
                                <div className="col-12">
                                    <p className="infos-ativos"><strong>Programa:</strong> {item.nomePrograma}</p>
                                    <p className="infos-ativos"><strong>Episódio:</strong> {item.nomeEpisodio}</p>
                                    <p className="infos-ativos"><strong>Data de publicação:</strong> {moment(item.dtPublicacao).format("DD/MM/YYYY")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                break;
            case 4:
                _layout = <div className="card-body pt-3">
                    <div className="row no-gutters">

                        <div className="col-lg-9 col-12  px-lg-4 px-0">
                            <div className="row">
                                <div className="col-12">
                                    <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                                    <p className="infos-ativos"><strong>Descrição:</strong> {item.descricao}</p>
                                    <p className="infos-ativos"><strong>Link:</strong> <a href={item.uri}>{item.uri}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                break;
            case 5:
                _layout = <div className="card-body pt-3">
                    <div className="row no-gutters">
                        <div className="col-lg-9 col-12  px-lg-4 px-0">
                            <div className="row">
                                <div className="col-12">
                                    <p className="infos-ativos"><strong>Título:</strong> {item.titulo}</p>
                                    <p className="infos-ativos"><strong>Descrição:</strong> {item.descricao}</p>
                                    <p className="infos-ativos"><strong>Link:</strong> <a href={item.uri}>{item.uri}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                break;
            default: _layout = <React.Fragment></React.Fragment>
        }
        return _layout;
    }

    defineRota(item) {
        let _rota;

        switch (item.tipo) {
            case 1:
                _rota = `/conteudo/${item.categoria.toLowerCase()}/${item.edicao}/${item.idConteudo}`
                break;
            case 2:
                _rota = `/multimidia/podcasts/${item.idPodcastPrograma}/${item.idPodcastEpisodio}`
                break;
            case 3:
                _rota = `/multimidia/videos/${item.idVideoPrograma}/${item.idVideoEpisodio}`
                break;
            default: _rota = `/`
        }
        return _rota;
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }

    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    render() {
        const {
            alteraPosicao,
            conteudos,
            toggleModalExcluirConteudo
        } = this.props;


        return (
            <div className="row lista-conteudo">
                {(!conteudos || conteudos.length <= 0) && (
                    <div className="col-12 text-center py-3">
                        <h3>Não há conteúdos cadastrados.</h3>
                    </div>
                )}

                {!!conteudos && conteudos.map((item, indice) => {
                    return (
                        <div className="col-lg-10 col-12 pt-2 mt-3 offset-lg-1 offset-0 content-product" key={indice}>
                            <div className="row no-gutters">
                                <div className="col-12">
                                    <div className="card bg-white w-100">
                                        <div className={`${item.ativo ? "bg-purple text-white" : "bg-gray text-secondary"} card-header`}>
                                            <div className="row no-gutters">
                                                <div className="col-12 pb-3 pb-lg-0">
                                                    <div className="row no-gutters">
                                                        <div className="col-3 border-white">
                                                            <span className="tipo-label">{item.tipoLabel}</span>

                                                        </div>
                                                        {item.tipo === 1 ? (
                                                            <React.Fragment>
                                                                <div className="col-2 text-left">
                                                                    <span className={`badge badge-${Geral.badgeProductType(item.categoria)}`}>{item.categoria.toUpperCase()} {item.edicao}</span>
                                                                </div>
                                                                <div className="col-2">
                                                                    {
                                                                        item.categoria.toLowerCase() !== this.props.periodico && (
                                                                            <span className="badge badge-warning">Conteúdo relacionado</span>
                                                                        )
                                                                    }
                                                                </div>
                                                                <div className="col-5 text-right border-white d-flex justify-content-end align-items-center">
                                                                    {conteudos.length !== 1 && (
                                                                        <React.Fragment>
                                                                            <i className={`${indice === 0 ? 'd-none' : 'cursor-pointer'} fas fa-arrow-up icones-destaques-ativos px-3`} onClick={() => alteraPosicao(item.idItem, -1, indice)}></i>
                                                                            <i className={`${indice === (conteudos.length - 1) ? 'd-none' : 'cursor-pointer'} fas fa-arrow-down icones-destaques-ativos px-3`} onClick={() => alteraPosicao(item.idItem, +1, indice)}></i>
                                                                        </React.Fragment>
                                                                    )}
                                                                    {item.ativo ? <span className="ml-3 badge text-purple bg-white">Disponível</span> : <span className="ml-3 badge badge-secondary">Indisponível</span>}
                                                                    <i className={`${item.ativo ? 'far fa-eye-slash' : 'far fa-eye'} icones-destaques-ativos cursor-pointer`} onClick={() => this.props.mudaStatusItemConteudo({ idItem: item.idItem, novoStatus: !item.ativo })}></i>

                                                                    <i className="far fa-trash-alt ml-3 mr-1 cursor-pointer" onClick={() => toggleModalExcluirConteudo(item.idItem)}></i>

                                                                </div>
                                                            </React.Fragment>
                                                        ) : (
                                                            <div className="col-9 text-right border-white d-flex justify-content-end align-items-center">
                                                                {conteudos.length !== 1 && (
                                                                    <React.Fragment>
                                                                        <i className={`${indice === 0 ? 'd-none' : 'cursor-pointer'} fas fa-arrow-up icones-destaques-ativos px-3`} onClick={() => alteraPosicao(item.idItem, -1, indice)}></i>
                                                                        <i className={`${indice === (conteudos.length - 1) ? 'd-none' : 'cursor-pointer'} fas fa-arrow-down icones-destaques-ativos px-3`} onClick={() => alteraPosicao(item.idItem, +1, indice)}></i>
                                                                    </React.Fragment>
                                                                )}
                                                                {item.ativo ? <span className="ml-3 badge text-purple bg-white">Disponível</span> : <span className="ml-3 badge badge-secondary">Indisponível</span>}
                                                                <i className={`${item.ativo ? 'far fa-eye-slash' : 'far fa-eye'} icones-destaques-ativos cursor-pointer`} onClick={() => this.props.mudaStatusItemConteudo({ idItem: item.idItem, novoStatus: !item.ativo })}></i>

                                                                <i className="far fa-trash-alt ml-3 mr-1 cursor-pointer" onClick={() => toggleModalExcluirConteudo(item.idItem)}></i>

                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className={`card-body pt-3`}>
                                            {this.renderizaCardsContent(item)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })
                }
            </div>

        )
    }
}
export default ContentList;